import {Component, OnInit, ElementRef, ViewChild, ChangeDetectorRef, OnDestroy} from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { UserRolesService } from '../../../shared/services';
import { TenantType } from '../../../shared/helpers/app.constants';
import { countries as COUNTRIES_DATA } from '../../../shared/helpers/data/countries';
import { TreatmentService } from '../../../shared/services/treatment.service';
import { find } from 'lodash';
import { UserAuthService } from '../../../shared/services/user-auth.service';

@Component({
  selector: 'app-upload-treatment-add-well',
  templateUrl: './upload-treatment-add-well.component.html',
  styleUrls: ['./upload-treatment-add-well.component.scss']
})
export class UploadTreatmentAddWellComponent implements OnInit, OnDestroy {

  curForm: FormGroup;
  formControl: any = {};
  listSuggestWellApi = [];
  timer: any;
  // Operator Company
  userOperatorCompany: boolean = false;
  operatorCompanies = [];
  selectedOperatorCompanies = [];
  // Service Company
  userServiceCompany: boolean = false;
  serviceCompanies = [];
  selectedServiceCompanies = [];

  isOpenSearchWell = false;
  // Country
  listCountries = COUNTRIES_DATA;
  selectedListContries = [];
  // State
  listStates: any[] = [];
  selectedListStates = [];

  currentCompanyId: number;
  // Disabled All Input
  disabledInput: boolean = false;

  @ViewChild('inputSearch') inputSearchEle: ElementRef;

  constructor(
    protected dialogRef: NbDialogRef<any>,
    private fb: FormBuilder,
    private userRolesService: UserRolesService,
    private treatmentService: TreatmentService,
    private userAuthService: UserAuthService,
    private ref: ChangeDetectorRef
  ) {
    this.createForm();
  }

  ngOnInit() {
    const user = this.userAuthService.getUserInfo();
    this.currentCompanyId = user.companyId;
    if (user && user.companyType === 'Service') {
      this.userServiceCompany = true;
      this.selectedServiceCompanies = [{
        id : user.companyId,
        name: user.company
      }];
      this.formControl['serviceCompanyId'].setValue(user.companyId);
    } else if (user && user.companyType === 'Operator') {
      this.userOperatorCompany = true;
      this.selectedOperatorCompanies = [{
        id : user.companyId,
        name: user.company
      }];
      this.formControl['operatorCompanyId'].setValue(user.companyId);
    }
    // init list companies
    if (!this.userServiceCompany) {
      this.treatmentService.getListCompanyByType(TenantType.ServiceCompany).subscribe(response => {
        if (response && response.result) {
          this.serviceCompanies = response.result.items;
        }
      });
    }
    if (!this.userOperatorCompany) {
      this.treatmentService.getListCompanyByType(TenantType.OperatorCompany).subscribe(response => {
        if (response && response.result) {
          this.operatorCompanies = response.result.items;
        }
      });
    }
  }

  ngOnDestroy() {
    this.ref.detach();
  }

  close() {
    this.dialogRef.close();
  }

  createForm() {
    this.curForm = this.fb.group({
      wellName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100), Validators.pattern('[A-Za-z0-9_%-\\s]*')]],
      wellAPI: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100), Validators.pattern('[A-Za-z0-9\-]*')]],
      jobStartDate: [new Date(), []],
      country: [null, [Validators.required]],
      state: [null, []],
      county: ['', []],
      operatorCompanyId: [null, [Validators.required]],
      serviceCompanyId: [null, [Validators.required]],
      jobType: ['', []],
      formation: ['', [Validators.minLength(2), Validators.maxLength(50), Validators.pattern('[A-Za-z0-9\\s]*')]],
      latitude: [0, []],
      longitude: [0, []],
      elevation: [0, []],
      noTreatmentsUpload: [1, [
        Validators.required,
        Validators.min(0),
        Validators.max(100)
      ]],
    });

    for (const key in this.curForm.controls) {
      if (this.curForm.controls.hasOwnProperty(key)) {
        this.formControl[key] = this.curForm.controls[key];
      }
    }
  }

  submitForm() {
    if (this.curForm.valid) {
      // submit form
      const payload = this.toSubmitPayload(this.curForm.value);
      this.dialogRef.close(payload);
    }
  }

  toSubmitPayload(formData) {
    if (formData) {
      const result = {...formData};
      result.operatorCompanyId = result.operatorCompanyId * 1;
      result.serviceCompanyId = result.serviceCompanyId * 1;

      return result;
    }
    return {};
  }

  handleChangeInputSearchWell(value) {
    if (value) {
      this.treatmentService.suggestWellApi(this.currentCompanyId, value).subscribe(response => {
        if (response && response.result) {
          this.isOpenSearchWell = true;
          this.ref.detectChanges();
          this.listSuggestWellApi = response.result.map(item => {
            return { id: item.wellId, label: item.wellUid, selected: false };
          });
        }
      });
    } /*else {
      this.listSuggestWellApi = [];
      this.resetFormValues();
    }*/
  }

  keyupInputSearchWell(event) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.handleChangeInputSearchWell(event.target.value);
    }, 500);
  }

  blurInputSearchWell(event?) {
    this.isOpenSearchWell = false;
    this.ref.detectChanges();
  }

  toggleDisableFields(isDisable: boolean) {
    for (const key in this.formControl) {
      if (this.formControl.hasOwnProperty(key)) {
        if (typeof this.formControl[key].disable === 'function' && key !== 'wellAPI') {
          if (isDisable) {
            this.formControl[key].disable();
          } else {
            this.formControl[key].enable();
          }
        }
      }
    }
  }

  selectWellApiHandler(item) {
    if (item && item.id) {
      this.treatmentService.getCurrentWellInfo(item.id).subscribe(response => {
        if (response && response.result) {
          this.disabledInput = true;
          this.ref.detectChanges();
          // set values
          for (const key in response.result) {
            if (this.formControl.hasOwnProperty(key)) {
              if (key === 'jobStartDate') {
                const dataTime = new Date(response.result[key]);
                if (dataTime && dataTime.getFullYear() >= 1970) {
                  this.formControl[key].setValue(dataTime);
                } else {
                  this.formControl[key].setValue(new Date());
                }
              } else {
                this.formControl[key].setValue(response.result[key]);
              }
              if (key === 'country') {
                if (response.result[key]) {
                  this.listStates = this.getListStates(response.result[key]);
                  this.selectedListContries = [{name: response.result[key]}];
                } else {
                  this.selectedListContries = [];
                }
                const country = this.formControl[key].value;
                this.formControl[key].setValidators([]);
                this.formControl[key].reset();
                this.formControl[key].setValue(country);
              }
              if (key === 'state') {
                if (this.listStates && this.listStates.length > 0) {
                  const stateValue = find(this.listStates, {name: this.formControl['state'].value});
                  if (stateValue) {
                    this.selectedListStates = [stateValue];
                  } else {
                    this.selectedListStates = [];
                  }
                }
              }
              if (key === 'operatorCompanyId' && response.result[key]) {
                this.selectedOperatorCompanies = [{
                  id: response.result[key],
                  name: response.result['operatorCompanyName']
                }];
              }
              if (key === 'serviceCompanyId' && response.result[key]) {
                this.selectedServiceCompanies = [{
                  id: response.result[key],
                  name: response.result['serviceCompanyName']
                }];
              }
              if (key === 'noTreatmentsUpload') {
                this.formControl[key].setValidators([
                  Validators.required,
                  Validators.min(0),
                  Validators.max(100),
                ]);
              }
            }
          }
          setTimeout(() => {
            this.isOpenSearchWell = false;
            this.ref.detectChanges();
          }, 500);
        }
      });
    }
  }

  resetFormValues() {
    for (const key in this.curForm.controls) {
      if (this.curForm.controls.hasOwnProperty(key)) {
        this.formControl[key].setValue('');
        if (key === 'country') {
          this.formControl[key].setValue(null);
          // Set Validator Country
          this.formControl['country'].setValidators([Validators.required]);
          this.formControl['country'].reset();
          this.selectedListContries = [];
        }
        if (key === 'state') {
          this.formControl[key].setValue(null);
          this.selectedListStates = [];
        }
        if (key === 'operatorCompanyId') {
          this.selectedOperatorCompanies = [];
        }
        if (key === 'serviceCompanyId') {
          this.selectedServiceCompanies = [];
        }
        if (key === 'latitude' || key === 'longitude') {
          this.formControl[key].setValue(0);
        }
        if (key === 'jobStartDate') {
          this.formControl[key].setValue(new Date());
        }
        if (key === 'noTreatmentsUpload') {
          this.formControl[key].setValue(1);
          this.formControl[key].setValidators([
            Validators.required,
            Validators.min(1),
            Validators.max(100)
          ]);
        }
      }
    }
  }

  changeCountryHandler(event) {
    this.formControl['country'].setValue(event.text);
    const countryName = event.text;
    if (countryName) {
      this.listStates = this.getListStates(countryName);
      if (this.listStates && this.listStates.length > 0) {
        this.formControl['state'].setValue(this.listStates[0].name);
        this.selectedListStates = [this.listStates[0]];
      } else {
        this.formControl['state'].setValue('');
        this.selectedListStates = [];
      }
    }
  }

  getListStates(countryName: string) {
    if (countryName) {
      const country = COUNTRIES_DATA.find(item => item.name === countryName);
      if (country && country.states) {
        return country.states;
      }
    }
    return [];
  }

  onBlurFormControl(control: any) {
    control.markAsTouched();
  }

  clearWellAPI() {
    this.listSuggestWellApi = [];
    this.resetFormValues();
    this.disabledInput = false;
    this.ref.detectChanges();
  }

}
